import React from 'react';
import cn from "./../../../../lib/bem";
import ico_circle_persona from './../../../../assets/svg/ico_circle_persona.svg';
import ico_circle_celular from './../../../../assets/svg/ico_circle_celular.svg';
import ico_circle_abuelita from './../../../../assets/svg/ico_circle_abuelita.svg';
import ico_circle_bolsa from './../../../../assets/svg/ico_circle_bolsa.svg';

import './seccion_funciona.scss';

const SeccionFunciona = () => {

    const classes = cn("seccionFunciona");

    return ( 
        <div className={classes()}>
            <p className={classes('titleFunciona')} ><b>¿Cómo funciona?</b></p>
            <p className={classes('descrFunciona')}>El Seguro Fondo Vida Garantizado te permite invertir a un plazo fijo con una rentabilidad garantizada desde el inicio. Además, podrás proteger a tus seres queridos con un seguro de vida en caso de fallecimiento. Te lo explicamos con este ejemplo:</p>
            <br/><br/>
            <div className={classes('mobileFunciona')}>
                <div className={classes("cardFunciona")}>
                    <div>
                        <img src={ico_circle_persona} alt={"ico circle persona"} />
                    </div>
                    <div>
                        <p className={classes("cardFuncionaP")}><b>Inversión inicial</b> José quiere rentabilizar sus ahorros, pero necesita que estos le den un rendimiento fijo.</p>
                    </div>
                </div>
                <div className={classes("cardLineFunciona")} ></div>
                <div className={classes("cardFunciona")}>
                    <div>
                        <img src={ico_circle_celular} alt={"ico circle celular"} />
                    </div>
                    <div>
                        <p className={classes("cardFuncionaP")}><b>Adquiere el Seguro Fondo Vida Garantizado</b> Decide comprar el Seguro Fondo Vida Garantizado, invirtiendo sus S/ 25,000 y recibiendo una rentabilidad fija de 4.39% anual por los próximos 3 años.</p>
                    </div>
                </div>
                <div className={classes("cardLineFunciona")} ></div>
                <div className={classes("cardFunciona")}>
                    <div>
                        <img src={ico_circle_abuelita} alt={"ico circle abuelita"} />
                    </div>
                    <div>
                        <p className={classes("cardFuncionaP")}><b>Protección</b> En caso de fallecimiento, los beneficiarios elegidos por José recibirían el seguro de vida, además de lo invertido y la rentabilidad ganada a la fecha.</p>
                    </div>
                </div>
                <div className={classes("cardLineFunciona")} ></div>
                <div className={classes("cardFunciona")}>
                    <div>
                        <img src={ico_circle_bolsa} alt={"ico circle bolsa"} />
                    </div>
                    <div>
                        <p className={classes("cardFuncionaP")}><b>Luego de 3 años</b> José recibió S/ 28,439 ganando S/ 3,439 más de la invertido.</p>
                    </div>
                </div>
            </div>
            <div className={classes('desktopFunciona')}>
                <div className={classes("gridFunciona")}>
                    <div className={classes("gridFuncionaCard")}>
                        <div>
                            <img src={ico_circle_persona} alt={"ico circle persona"} />
                        </div>
                        <div className={classes("gridFuncionaCardDiv")}>
                            <div className={classes("gridFuncionaCircle")}></div>
                            <p><b>Inversión inicial</b></p><p style={{marginBlockStart:'0'}}>José quiere rentabilizar sus ahorros, pero necesita que estos le den un rendimiento fijo.</p>
                        </div>
                    </div>
                    <div className={classes("gridFuncionaLineH")}></div>
                    <div className={classes("gridFuncionaCard")}>
                        <div>
                            <img src={ico_circle_celular} alt={"ico circle celular"} />
                        </div>
                        <div className={classes("gridFuncionaCardDiv")}>
                            <div className={classes("gridFuncionaCircle")}></div>
                            <p><b>Adquiere el Seguro Fondo Vida Garantizado</b> Decide comprar el Seguro Fondo Vida Garantizado, invirtiendo sus S/ 25,000 y recibiendo una rentabilidad fija de 4.39% anual por los próximos 3 años.</p>
                        </div>
                    </div>
                    <div className={classes("gridFuncionaLineH")}></div>
                    <div className={classes("gridFuncionaCard")}>
                        <div>
                            <img src={ico_circle_abuelita} alt={"ico circle abuelita"} />
                        </div>
                        <div className={classes("gridFuncionaCardDiv")}>
                            <div className={classes("gridFuncionaCircle")}></div>
                            <p><b>Protección</b></p><p style={{marginBlockStart:'0'}}>En caso de fallecimiento, los beneficiarios elegidos por José recibirían el seguro de vida, además de lo invertido y la rentabilidad ganada a la fecha.</p>
                        </div>
                    </div>
                    <div className={classes("gridFuncionaLineH")}></div>
                    <div className={classes("gridFuncionaCard")}>
                        <div>
                            <img src={ico_circle_bolsa} alt={"ico circle bolsa"} />
                        </div>
                        <div className={classes("gridFuncionaCardDiv")}>
                            <div className={classes("gridFuncionaCircle")}></div>
                            <p><b>Luego de 3 años</b></p><p style={{marginBlockStart:'0'}}>José recibió S/ 28,439 ganando S/ 3,439 más de la invertido.</p>
                        </div>
                    </div>
                </div>
            </div>
            <br/><br/>
        </div>
    );
}
 
export default SeccionFunciona;